import React from 'react';
import { Stack, Text } from '@/theme/components';
import { Icons, styled } from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';

type ProgressBreadcrumbsProps = {
  steps: { [step: number]: string };
  currentStep: number;
};

const CompleteIcon = styled(Stack)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.progress?.main || theme.palette.primary.dark,
  borderRadius: '50%',
  height: '28px',
  width: '28px',
}));

const IncompleteIcon = styled(Stack)(({ theme }) => ({
  color: theme.palette.success.main,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.success.main}`,
  borderRadius: '50%',
  height: '28px',
  width: '28px',
  opacity: '40%',
}));

export default function ProgressBreadcrumbs({
  steps,
  currentStep,
}: ProgressBreadcrumbsProps) {
  const stepKeys = Object.keys(steps);
  const { isMobile } = useScreenSize();

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      alignItems={isMobile ? 'flex-start' : 'center'}
      justifyContent="center"
      spacing={1}
    >
      {stepKeys.map((key: string) => (
        <Stack key={key} direction="row" alignItems="center" spacing={1}>
          {+key <= currentStep ? (
            <CompleteIcon alignItems="center" justifyContent="center">
              {+key < currentStep ? (
                <Icons.Check fontSize="small" />
              ) : (
                <Text>{key}</Text>
              )}
            </CompleteIcon>
          ) : (
            <IncompleteIcon alignItems="center" justifyContent="center">
              <Text>{key}</Text>
            </IncompleteIcon>
          )}
          <Text
            color="success.main"
            sx={{ opacity: +key === currentStep ? '1' : '0.4' }}
          >
            {steps[+key]}
          </Text>
          {!isMobile && +key !== stepKeys.length && (
            <Icons.ChevronRight sx={{ opacity: '0.4' }} />
          )}
        </Stack>
      ))}
    </Stack>
  );
}
